var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 665,
    height: 665,
    viewBox: "0 0 665 665",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M332.489 664.906C516.098 664.906 664.942 516.062 664.942 332.453C664.942 148.844 516.098 0 332.489 0C148.88 0 0.0358887 148.844 0.0358887 332.453C0.0358887 516.062 148.88 664.906 332.489 664.906Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M316.303 332.901L331.816 353.477L315.113 371.773L189.963 508.81H152.506L299.46 350.996L316.303 332.901Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M511.954 156.227L375.867 305.245L359.72 322.923L344.501 302.625L360.725 285.203L480.819 156.227H511.954Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M375.867 305.245L360.725 285.202L263.541 156.543H152.985L299.46 350.996L315.112 371.773L418.572 509.127H529.878L375.867 305.245ZM331.816 353.478L316.303 332.902L202.524 181.921H253.972L344.501 302.626L359.72 322.924L480.34 483.753H429.99L331.816 353.478Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.384899152aa3e28fdc59a853592d96ea.svg";
export { ForwardRef as ReactComponent };